import { OnInit, Component, Inject } from '@angular/core';
import { Utility } from '../../../common/utility';
import { BaseService } from '../../../shared/services/base.service';
import { DialogService } from '../../../shared/services/dialog.service';
import { FormBuilder, Validators } from '@angular/forms';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { FormGroup } from '@angular/forms';
import { VaccineService } from '../../master-data/vaccine/vaccine.service';
import { VaccineStockModel } from '../../../models/master-data/vaccine-stock.model';
import { ManageVaccineService } from './manage-vaccine.service';
import { ValidationService } from '../../../shared/services/validation.service';
import { AppMessages } from '../../../shared/constants/messages';

@Component({
  selector: 'manage-vaccine-edit-popup',
  templateUrl: 'manage-vaccine-edit-popup.component.html',
  providers: [VaccineService, ManageVaccineService, ValidationService]
})
export class ManageVaccineEditPopupComponent implements OnInit {
  editVaccineForm: FormGroup;
  minDate: Date;
  maxDate: Date;
  public vaccineList: Array<any>;
  public reasonList = [];
  public isSuccess = false;
  constructor(
    public utility: Utility,
    public baseService: BaseService,
    public dialogService: DialogService,
    private formBuilder: FormBuilder,
    public dialogRef: MdDialogRef<ManageVaccineEditPopupComponent>,
    public vaccineService: VaccineService,
    public manageVaccineService: ManageVaccineService,
    @Inject(MD_DIALOG_DATA) public data: { vaccineStock: any, vaccineId: string, centreId: string },
  ) {
    const date = new Date();
    this.minDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1, 0, 0, 0);
    this.createForm();
  }

  ngOnInit() {
    this.getVaccineList();
    this.getReasonList((callback) => {
      if (callback) {
        this.setData();
      }
    });
  }

  createForm() {
    this.editVaccineForm = this.formBuilder.group({
      vaccineId: [null, [Validators.required]],
      batchNumber: [null, [Validators.required]],
      expiredDate: [null, [Validators.required]],
      quantity: [null, [Validators.required, ValidationService.isValidNumberFromTo(1, 2000)]],
      reason: ['', [Validators.required]],
      adjustment: [0, [Validators.required, ValidationService.isValidNumberFromTo(-500, 500)]],
      centreId: [null]
    });
    this.editVaccineForm.controls.vaccineId.disable();
    this.editVaccineForm.controls.batchNumber.disable();
    this.editVaccineForm.controls.quantity.disable();
  }

  setData() {
    this.editVaccineForm.controls['batchNumber'].setValue(this.data.vaccineStock.batchNumber);
    this.editVaccineForm.controls['quantity'].setValue(this.data.vaccineStock.count);
    this.editVaccineForm.controls['expiredDate'].setValue(new Date(this.data.vaccineStock.expiredDate));
    this.editVaccineForm.controls['adjustment'].setValue(this.data.vaccineStock.adjustment || 0);
    this.editVaccineForm.controls['vaccineId'].setValue(this.data.vaccineId);
    this.editVaccineForm.controls['centreId'].setValue(this.data.centreId);
    this.editVaccineForm.controls['reason'].setValue(
      this.reasonList.length > 0 ?
        (this.data.vaccineStock.reason || '') : '');

  }
  getVaccineList() {
    this.vaccineService.getVaccineList(this.data.centreId).subscribe(result => {
      if (result) {
        const data = result.json();
        if (data) {
          this.vaccineList = data['list'];
          this.editVaccineForm.controls['vaccineId'].setValue(this.vaccineList.find(x => x.name === this.data.vaccineStock.vaccine).id);
        }
      }
    });
  }

  getReasonList(callback?) {
    this.manageVaccineService.getReasonList().subscribe(
      result => {
        if (result) {
          const data = result.json();
          this.reasonList = data || [];
        }
        callback(true);
      }, error => callback(true)
    );
  }

  calcCount(currentCount, adjustment): number {
    currentCount = isNaN(Number.parseInt(currentCount.toString(), 0)) ? 0 : parseInt(currentCount.toString(), 0);
    adjustment = isNaN(Number.parseInt(adjustment.toString(), 0)) ? 0 : parseInt(adjustment.toString(), 0);
    const total = currentCount + adjustment;
    return total;
  }

  validateBeforeSubmit(): boolean {
    // const date = new Date(this.editVaccineForm.controls.expiredDate.value);
    // date.setHours(0, 0, 0, 0);
    // this.editVaccineForm.controls.expiredDate.setValue(this.utility.convertDateToString(date));
    const totalCount = this.calcCount(this.editVaccineForm.controls.quantity.value, this.editVaccineForm.controls.adjustment.value);
    if (totalCount < 0) {
      // show error
      this.dialogService.openErrorDialog({ message: AppMessages.vaccine.notBeNegative });
      return false;
    }
    this.editVaccineForm.controls.quantity.setValue(totalCount);
    // this.editVaccineForm.updateValueAndValidity();
    return true;
  }

  onSubmit() {
    this.markAsTouch();
    if (this.editVaccineForm.valid && this.editVaccineForm.dirty) {
      // check new count > 0
      const isValid = this.validateBeforeSubmit();
      if (isValid) {
        const form = this.editVaccineForm.value;
        form.expiredDate = this.utility.convertDateToString(form.expiredDate);
        this.manageVaccineService.updateVaccineBatch(this.data.vaccineStock.id, form).subscribe(
          result => {
            if (result) {
              const data = result.json();
              this.dialogService.openSuccessDialog({ message: data['message'] });
              this.isSuccess = true;
              this.onCloseDialog();
            }
          }
        );
      }
    }
  }

  markAsTouch() {
    for (const key in this.editVaccineForm.controls) {
      if (this.editVaccineForm.controls.hasOwnProperty(key)) {
        this.editVaccineForm.controls[key].markAsTouched();
        this.editVaccineForm.controls[key].markAsDirty();
        this.editVaccineForm.controls[key].updateValueAndValidity();
      }
    }
  }

  onCloseDialog() {
    this.dialogRef.close(this.isSuccess);
  }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/centre/manage-vaccine/manage-vaccine-edit-popup.component.ts